import React, { useEffect, useState } from "react";
import { Form, Input, Modal, Select, Button } from "antd";
import UserService from "../../services/UserService";
import RoleService from "../../services/RoleService";
import { IRoleResponseData } from "../../types/Role";
import { generatePassword, openNotification } from "../../utils";

interface UserCreateModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const UserCreateModal: React.FC<UserCreateModalProps> = ({
  open,
  onClose,
  onSuccess,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState<IRoleResponseData[]>([]);
  const loginMethod = Form.useWatch("loginMethod", form) || "LOCAL";

  useEffect(() => {
    if (open) {
      RoleService.getAll()
        .then((response: any) => setRoles(response.data))
        .catch((error) => console.log(error));
    }
  }, [open]);

  const handleSubmit = (values: any) => {
    setLoading(true);
    UserService.create({
      username: values.username,
      password: values.loginMethod === "LOCAL" ? values.password : undefined,
      firstName: values.firstName,
      lastName: values.lastName,
      roleIdList: values.roleIdList,
      gsmPortalEmployeeId: values.gsmPortalEmployeeId,
      phoneNumber: values.phoneNumber,
      loginMethod: values.loginMethod || "LOCAL",
    })
      .then(() => {
        openNotification("success", "Başarılı", "Kullanıcı oluşturuldu");
        form.resetFields();
        onSuccess();
        onClose();
      })
      .catch((error) => {
        const message = error?.response?.data?.message || "Kullanıcı oluşturulamadı";
        openNotification("error", "Hata", message);
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal
      title="Yeni Kullanıcı"
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      width={560}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{ loginMethod: "LOCAL" }}
      >
        <Form.Item
          name="username"
          label="Kullanıcı adı"
          rules={[{ required: true, message: "Kullanıcı adı zorunludur" }]}
        >
          <Input placeholder="email@mongerlab.com" />
        </Form.Item>
        <Form.Item
          name="loginMethod"
          label="Giriş yöntemi"
          rules={[{ required: true, message: "Giriş yöntemi seçin" }]}
        >
          <Select>
            <Select.Option value="LOCAL">Şifre ile (Local)</Select.Option>
            <Select.Option value="GOOGLE">Google ile</Select.Option>
            <Select.Option value="GATE">Gate ile</Select.Option>
          </Select>
        </Form.Item>
        {loginMethod === "LOCAL" && (
          <>
            <Form.Item
              name="password"
              label="Şifre"
              rules={[
                { required: true, message: "Şifre zorunludur" },
                { min: 12, message: "En az 12 karakter" },
              ]}
            >
              <Input.Password placeholder="Şifre" />
            </Form.Item>
            <Form.Item>
              <Button
                onClick={() => form.setFieldsValue({ password: generatePassword(14) })}
              >
                Rastgele Şifre Oluştur
              </Button>
            </Form.Item>
          </>
        )}
        <Form.Item
          name="firstName"
          label="Ad"
          rules={[{ required: true, message: "Ad zorunludur" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="lastName"
          label="Soyad"
          rules={[{ required: true, message: "Soyad zorunludur" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="roleIdList"
          label="Roller"
          rules={[{ required: true, message: "En az bir rol seçin" }]}
        >
          <Select mode="multiple" placeholder="Rol seçin">
            {roles.map((role) => (
              <Select.Option key={role.id} value={role.id}>
                {role.description}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="gsmPortalEmployeeId" label="GSM Portal Employee ID">
          <Input />
        </Form.Item>
        <Form.Item name="phoneNumber" label="Telefon">
          <Input />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Oluştur
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UserCreateModal;
